/** 历史英文错误码 → 中文提示（兼容旧接口响应） */
const LEGACY_API_MESSAGE_ZH = {
  SYSTEM_ID_MISMATCH: '请选择正确系统',
  SYSTEM_MISMATCH: '请选择正确系统',
  SYSTEM_ID_REQUIRED: '请选择系统',
  SYSTEM_DISABLED: '该系统已停用'
}

export function resolveApiMessage(message) {
  if (!message) return '请求失败'
  return LEGACY_API_MESSAGE_ZH[message] || message
}

export function isSystemMismatchMessage(message) {
  const resolved = resolveApiMessage(message)
  return resolved === '请选择正确系统'
}
